const getSizeDimension = (
  size: google.maps.Size | null | undefined,
  axis: 'width' | 'height',
  fallback: number
) => {
  if (!size) return fallback;
  const value = axis === 'width' ? size.width : size.height;
  return Number.isFinite(value) ? value : fallback;
};

const getPointValue = (
  point: google.maps.Point | null | undefined,
  axis: 'x' | 'y',
  fallback: number
) => {
  if (!point) return fallback;
  const value = axis === 'x' ? point.x : point.y;
  return Number.isFinite(value) ? value : fallback;
};

/* eslint-disable import/prefer-default-export */
export const createMarkerContent = (icon?: google.maps.Icon | string): HTMLElement => {
  const wrapper = document.createElement('div');
  wrapper.style.display = 'inline-flex';
  wrapper.style.lineHeight = '0';
  wrapper.style.pointerEvents = 'auto';

  const img = document.createElement('img');
  img.draggable = false;
  img.alt = '';

  if (typeof icon === 'string') {
    img.src = icon;
    img.width = 32;
    img.height = 32;
    wrapper.style.transform = 'translate(-50%, -100%)';
  } else if (icon?.url) {
    img.src = icon.url;
    img.width = getSizeDimension(icon.scaledSize, 'width', 32);
    img.height = getSizeDimension(icon.scaledSize, 'height', 32);

    const anchorX = getPointValue(icon.anchor, 'x', img.width / 2);
    const anchorY = getPointValue(icon.anchor, 'y', img.height);
    wrapper.style.transform = `translate(-${anchorX}px, -${anchorY}px)`;
  } else {
    img.width = 24;
    img.height = 24;
    wrapper.style.transform = 'translate(-50%, -50%)';
  }

  wrapper.appendChild(img);
  return wrapper;
};
